<mat-toolbar class="topbar horizontal-topbar gap-5">
  <div class="container">
    <div class="d-none d-sm-flex">
      <app-branding></app-branding>
    </div>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileNav.emit()"
      class="d-flex align-items-center justify-content-center d-lg-none m-x-4"
    >
      <i
        class="iconify icon-20 d-flex"
        data-icon="solar:hamburger-menu-line-duotone"
      ></i>
    </button>
    <!-- --------------------------------------------------------------- -->

    <!-- --------------------------------------------------------------- -->
    <!--  Search -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-icon-button
      (click)="openDialog()"
      class="d-flex align-items-center justify-content-center m-x-4"
    >
      <i class="iconify icon-20 d-flex" data-icon="solar:magnifer-outline"></i>
    </button>

    <div class="d-none d-lg-flex">
      <button
        mat-icon-button
        [matMenuTriggerFor]="appsmenu"
        aria-label="links"
        class="d-flex align-items-center justify-content-center"
      >
        <i
          class="iconify icon-20 d-flex"
          data-icon="solar:widget-3-line-duotone"
        ></i>
      </button>
      <mat-menu #appsmenu="matMenu" class="apps-dd cardWithShadow">
        <div class="row">
          <div class="col-sm-8 p-r-0">
            <div class="p-32 p-b-0">
              <div class="row">
                @for(appdd of apps; track appdd.title) {
                <div class="col-sm-6 text-hover-primary">
                  <a
                    [routerLink]="[appdd.link]"
                    class="d-flex align-items-center text-decoration-none m-b-24"
                  >
                    <span
                      class="text-{{ appdd.color }} bg-light-{{
                        appdd.color
                      }} rounded icon-48 d-flex align-items-center justify-content-center"
                    >
                      <span
                        class="iconify icon-20"
                        [attr.data-icon]="appdd.icon"
                      ></span>
                    </span>

                    <div class="m-l-16">
                      <h5 class="f-s-14 f-w-600 m-0 hover-text">
                        {{ appdd.title }}
                      </h5>
                      <span class="f-s-12 text-muted">{{
                        appdd.subtitle
                      }}</span>
                    </div>
                  </a>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <img
              src="/assets/images/backgrounds/mega-dd-bg.jpg"
              alt="mega-dd-bg"
              class="mega-dd-bg"
            />
          </div>
        </div>
      </mat-menu>
    </div>

    <span class="flex-1-auto"></span>

    <!-- APScan (KYC / superadmin) -->
    @if (canAccessKycHeaderTools()) {
      @if (authService.is_aptokenaccess === true) {
        <button mat-flat-button (click)="logout_to_apscan()" class="apscan-btn connected bg-success text-white">
          <i-tabler name="logout" class="icon-20 d-flex"></i-tabler>
          <span>APScan</span>
        </button>
      } @else {
        <button mat-flat-button (click)="connect_to_apscan()" class="apscan-btn disconnected bg-error text-white">
          <i-tabler name="login" class="icon-20 d-flex"></i-tabler>
          <span>APScan</span>
        </button>
      }
    }

    <!-- Aether Document Collector — every user: the GED view is everyone's
         workspace; users without client-portal (KYC) rights land on it directly. -->
    <button
      mat-flat-button
      type="button"
      class="dataroom-admin-btn"
      aria-label="Open Aether Document Collector admin"
      (click)="openDataroomAdmin()">
      <mat-icon class="dataroom-admin-btn__icon">
        <i-tabler name="shield-lock" class="icon-20 d-flex"></i-tabler>
      </mat-icon>
      <span>Aether Document Collector</span>
    </button>

    <!-- Mobile Menu -->
    <button
      mat-icon-button
      (click)="toggleMobileFilterNav.emit()"
      class="d-flex d-lg-none justify-content-center m-x-4"
    >
      <i class="iconify icon-20 d-flex" data-icon="solar:menu-dots-outline"></i>
    </button>

    @if(options.theme=='light'){
    <button
      mat-icon-button
      aria-label="lightdark"
      class="d-flex justify-content-center"
      (click)="setlightDark('dark')"
    >
      <i-tabler class="d-flex icon-20" [name]="'moon'"></i-tabler>
    </button>
    }@else{
    <button
      mat-icon-button
      aria-label="lightdark"
      class="d-flex justify-content-center"
      (click)="setlightDark('light')"
    >
      <i-tabler class="d-flex icon-20" [name]="'sun'"></i-tabler>
    </button>
    }

    <!-- Notification dropdown (MatDash-style) -->
    <app-inapp-notification-bell itemType="notification" class="d-flex align-items-center"></app-inapp-notification-bell>
    <!-- Tasks to do dropdown -->
    <app-inapp-notification-bell itemType="task" class="d-flex align-items-center"></app-inapp-notification-bell>

    <!-- --------------------------------------------------------------- -->
    <!-- langugage Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button [matMenuTriggerFor]="flags" mat-icon-button>
      <img
        [src]="selectedLanguage.icon"
        class="rounded-circle object-cover icon-20"
      />
    </button>
    <mat-menu #flags="matMenu" xPosition="before" class="cardWithShadow">
      @for(lang of languages; track lang.icon) {
      <button mat-menu-item (click)="changeLanguage(lang)">
        <div class="d-flex align-items-center">
          <img
            [src]="lang.icon"
            class="rounded-circle object-cover m-r-8 icon-20"
          />
          <span class="f-s-14">{{ lang.language }}</span>
        </div>
      </button>
      }
    </mat-menu>

    <!-- --------------------------------------------------------------- -->
    <!-- Build stamp (the horizontal layout has no vertical sidebar) -->
    <!-- --------------------------------------------------------------- -->
    <app-version class="compact"></app-version>

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button
      mat-button
      [matMenuTriggerFor]="profilemenu"
      aria-label="Profile"
      class="profile-btn"
    >
      <div class="d-flex align-items-center gap-4">
        <img
          [src]="''"
          class="rounded-circle object-cover icon-35 profile-dd"
          width="35"
        />

        <i data-icon="solar:alt-arrow-down-bold" class="iconify f-s-8"></i>
      </div>
    </button>
    <mat-menu #profilemenu="matMenu" xPosition="before" class="topbar-dd cardWithShadow">
      <div class="p-x-32 p-y-16">
        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img
            [src]="''"
            class="rounded-circle"
            width="56"
          />
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0 d-flex align-items-center">

              <span class="f-s-14 d-block text-success m-l-4">Pro</span>
            </h6>
            <span class="text-muted"> </span>
            <!--<span class="text-muted"> {{ authService.getCurrentUser().groupdesc }} </span>-->
          </div>
        </div>
      </div>
      <div class="p-x-32 p-b-16">
        @for(profile of profiledd; track profile.title) {
        <a
          class="p-8 text-decoration-none d-block text-hover-primary"
          [routerLink]="[profile.link]"
        >
          <div class="d-flex align-items-center">
            <h5 class="f-s-14 f-w-600 m-0 lh-md hover-text">
              {{ profile.title }}
            </h5>
            @if(profile.new) {
            <span
              class="bg-light-error text-error rounded p-x-8 p-y-2 f-w-500 f-s-12 m-l-4"
              >5</span
            >
            }
          </div>
        </a>
        }
      </div>
    </mat-menu>
  </div>
</mat-toolbar>
